import { render } from "./VipLevelsList.vue?vue&type=template&id=13a05bab"
import script from "./VipLevelsList.vue?vue&type=script&lang=js"
export * from "./VipLevelsList.vue?vue&type=script&lang=js"

import "./VipLevelsList.vue?vue&type=style&index=0&id=13a05bab&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__